import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message/MessageSlice';
import UserManagementServices from '../../../service/user-management/UserManagementServices';

export const getLoadUsersList = createAsyncThunk(
  'Administration/LoadUsers',
  async (CompanyId, thunkAPI) => {
    const companyId = localStorage.getItem('companyId');
    const roleId = localStorage.getItem('roleId');
    const isAdmin = roleId === '1' || roleId === '2';
    try {
      const response = await UserManagementServices.getLoadUsers(
        isAdmin ? 0 : companyId || CompanyId,
        roleId,
      );
      return { usersList: response.data.data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const getLoadUsersListFromCompany = createAsyncThunk(
  'Administration/LoadUsers',
  async (CompanyId, thunkAPI) => {
    //  const roleId = localStorage.getItem("roleId")
    const roleId = 0;
    try {
      const response = await UserManagementServices.getLoadUsers(CompanyId, roleId);
      return { CompanyUsersList: response.data.data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const getLoadSelfEmployList = createAsyncThunk(
  'Administration/LoadUsers',
  async ({pageNumber, pageSize}, thunkAPI) => {
    debugger;
    try {
      const response = await UserManagementServices.getAllSelfEmployer(pageNumber, pageSize);
      return { selfUsersList: response.data.data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);


export const getLoadSelfEmployListData = createAsyncThunk(
  'Administration/LoadUsers',
  async (_, thunkAPI) => {
    debugger;
    try {
      const response = await UserManagementServices.getAllSelfEmployerData();
      return { selfUsersList: response.data.data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const resetUserData = createAsyncThunk('auth/resetUserData', async (userId, thunkAPI) => {
  try {
    const response = await UserManagementServices.resetUserData(userId);
    thunkAPI.dispatch(setMessage({ message: response.data.message, type: 'success' }));
    return response.data;
  } catch (error) {
    const message =
      (error.response && error.response && error.response.data.message) ||
      error.message ||
      error.toString();
    thunkAPI.dispatch(setMessage({ message, type: 'error' }));
    return thunkAPI.rejectWithValue(message);
  }
});

const AdministrationSlice = createSlice({
  name: 'Administration',
  initialState: {
    usersList: [],
    CompanyUsersList: [],
    selfUsersList: [],
    loading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder

      .addCase(getLoadUsersList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLoadUsersList.fulfilled, (state, action) => {
        state.loading = false;
        state.usersList = action.payload.usersList;
        state.CompanyUsersList = action.payload.CompanyUsersList;
        state.selfUsersList = action.payload.selfUsersList;
      })
      .addCase(getLoadUsersList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.usersList = [];
        state.CompanyUsersList = [];
        state.selfUsersList = [];
      })

      .addCase(resetUserData.pending, (state) => {
        state.loadingModal = true;
        state.error = null;
        state.success = false;
      })
      .addCase(resetUserData.fulfilled, (state) => {
        state.loadingModal = false;
        state.success = true;
      })
      .addCase(resetUserData.rejected, (state, action) => {
        state.loadingModal = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export default AdministrationSlice.reducer;
